import gql from 'graphql-tag';

export default gql`
  mutation principalSignature($input: PrincipalSignatureInput!) {
    principalSignature(input: $input) {
      id
    }
  }
`;
